/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 15:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type ComposedProps = WithI18nProps;

class NoSort extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-EmptyRules__CustomSorting">
        <p>{i18n.translate('AdminHTML.CustomSorting.DefaultSortingOptions.noItem')}</p>
      </div>
    );
  }
}

export default withI18n()(NoSort);
